import "@fontsource/noto-sans-jp"
import "./src/styles/base.css"
import "./src/styles/blog-contents-style.css"

let fadeObserver = null

const observeFadeInUp = () => {
    if (typeof document === "undefined") return

    if (fadeObserver) {
        fadeObserver.disconnect()
    }

    const elements = document.querySelectorAll(".fadeInUp")

    fadeObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("on")
                }
            })
        },
        {
            threshold: 0.1
        }
    )

    elements.forEach((el) => fadeObserver.observe(el))
}

const showInterviewOnBack = () => {
    if (typeof document === "undefined") return
    if (window.innerWidth > 896) return

    const interviewSec = document.querySelector(".interviewSec")
    if (!interviewSec) return

    // 戻ってきた時はINTERVIEW内のfadeInUpを表示状態にする
    interviewSec.querySelectorAll(".fadeInUp").forEach((el) => {
        el.classList.add("on")
    })
}

export const onRouteUpdate = () => {
    if (typeof document !== "undefined") {
        // DOM生成後に少し待ってObserverを設定
        requestAnimationFrame(() => {
            observeFadeInUp()
        })
    }
}

export const onClientEntry = () => {
    if (typeof document !== "undefined") {
        document.documentElement.classList.add("js")

        window.addEventListener("pageshow", (event) => {
            if (event.persisted) {
                // BFCacheから戻った場合
                requestAnimationFrame(() => {
                    showInterviewOnBack()
                    observeFadeInUp()
                })
            }
        })
    }
}